export default __webpack_public_path__ + "static/media/doc4.7921d580.png";